export default __webpack_public_path__ + "static/kuLeuven-fced93d10259e0fbe338528f5486e84c.svg";